import OBase from './OBase';
import * as Geometry from '../geometry';
import * as GeoMath from '../../math';

export default class ConstructPlane extends OBase {
  update () {
    let oTree = this.getVector3Input('Origin', false);
    let xTree = this.getVector3Input('X-Axis', false);
    let yTree = this.getVector3Input('Y-Axis', false);

    let output = this.getGenericObjectOutput('Plane');

    let dataTrees = [];
    var outDataTrees = [];
    dataTrees.push(oTree);
    dataTrees.push(xTree);
    dataTrees.push(yTree);

    Geometry.makeMultiplePairs(dataTrees, outDataTrees);

    let outTree = new Geometry.DataTree();
    for (let i = 0; i < outDataTrees[0].branches.length; i++) {
      for (let j = 0; j < outDataTrees[0].branches[i].length; j++) {
        var orig = outDataTrees[0].branches[i][j];
        var xaxis = outDataTrees[1].branches[i][j];
        var yaxis = outDataTrees[2].branches[i][j];
        let plane = new GeoMath.GHPlane(orig, xaxis, yaxis);

        outTree.add(plane, outDataTrees[0].paths[i]);
      }
    }

    output.value = outTree;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/ConstructPlane.js